import { Card, Heading, Separator } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';

import TransitionaryGoalRow from './TransitionaryGoalRow';
import { useTransitionaryGoals } from './TransitionaryGoalsProvider';

const TransitionaryGoalsSection: React.FC<React.PropsWithChildren<{}>> = () => {
  const { loading: isLoading, data } = useTransitionaryGoals();

  if (isLoading) {
    return <CardLoader />;
  }
  if (data?.transitionaryGoals && data.transitionaryGoals.length > 0) {
    return (
      <Card>
        <Card.Header css={{ padding: 'space.300' }}>
          <Heading variant="title200" as="h2">
            Other managed accounts
          </Heading>
        </Card.Header>
        <Card.Content>
          {(data?.transitionaryGoals || []).map((transitionaryGoal, index) => (
            <ErrorBoundary key={transitionaryGoal.name}>
              <Separator css={{ fullWidthWithInset: 'space.300' }} />
              <TransitionaryGoalRow {...transitionaryGoal} />
            </ErrorBoundary>
          ))}
        </Card.Content>
      </Card>
    );
  }
  return null;
};

export default TransitionaryGoalsSection;
